<script>
	import {API} from '../global.js'

	let loading = false
	let data = {}
	let userid = ''
	let _userid = ''
	let update = false
	let page =0
	let activos = true

	$: refresh = async () => {
		let solo_activos = activos ? 1 : 0
		loading = true
		let rs = await fetch(`${API}/usuarios/${_userid||''}?activo=${solo_activos}&rpp=10&p=${page}&u=${update}`)
		let ds = await rs.json()
		loading = false
		return ds || []
	}

	function submit(){
		page = 0
		_userid = userid
	}

	function reset(){
		page = 0
		_userid = userid = ''
	}

</script>

<div class="container">
	<form on:submit|preventDefault={submit} on:reset|preventDefault={reset}>
		<input type="text" bind:value={userid} placeholder="Buscar usuario">
		<button class="btn btn-primary btn-sm" type="submit"><i class="bi-search"></i></button>
		<button class="btn btn-dark btn-sm" type="reset"><i class="bi-x-lg"></i></button>
		<div class="form-check form-check-inline ms-4">
			<input class="form-check-input" type="checkbox" value="" id="flexCheckDisabled" bind:checked={activos}>
			<label class="form-check-label" for="flexCheckDisabled">Activos</label>
		</div>
	</form>

	{#await refresh()}
		<p>Loading....</p>
		{:then ds}

		<table class="table table-sm mt-3">
			<caption>
				<button class="btn btn-primary btn-sm"><i class="bi-arrow-left-right" on:click="{()=>update=!update}"></i></button>
				<button class="btn btn-dark btn-sm" disabled="{ds.page===0}" on:click="{()=>page=ds.page-1}"><i class="bi-chevron-left"></i></button>
				<button class="btn btn-dark btn-sm" disabled="{ds.eof}" on:click="{()=>page=ds.page+1}"><i class="bi-chevron-right"></i></button>
			</caption>
			<thead>	
				<tr>
					<th>#</th>
					<th>Usuario</th>
					<th>Nombre</th>
					<th>Tipo</th>
					<th>ACList</th>
					<th>Profile</th>
					<th>Status</th>
				</tr>
			</thead>
			<tbody>

			{#each ds.data as item, index}
				<tr>
					<td>{item.idgescom}</td>
					<td>{item.username}</td>
					<td>{item.fullname}</td>
					<td>{item.usertype}</td>
					<td><small>{item.aclist}</small></td>
					<td>{item.profile}</td>
					<td>{item.status}</td>
				</tr>
			{/each}
			</tbody>
		</table>
		
	{/await}
</div>

